// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "consent_form_submission".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { consentFormSubmissionStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "consent_form_submission" table (1:1 with a DB row, on the wire). */
export const consentFormSubmissionAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    appointmentId: z.string(),
    leadId: z.string(),
    templateId: z.string(),
    templateSnapshot: z.unknown(),
    status: z.enum(consentFormSubmissionStatusValues),
    fieldData: z.unknown(),
    signedByName: z.string().nullable(),
    signedAt: z.string().datetime().nullable(),
    signedIp: z.string().nullable(),
    signatureImageKey: z.string().nullable(),
    pdfKey: z.string().nullable(),
    pdfGenerationAttempts: z.number(),
    sentAt: z.string().datetime().nullable(),
    reminderSentAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=consentFormSubmission.js.map